import type { PetSchemeQuoteResult } from './SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '@/converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '../enums/DLDCommonValuesEnum'
import PetProposer from './PetProposer'
import PetRiskPet from './PetRiskPet'
import QuoteDetails from './QuoteDetails'

@JsonObject('PetQuoteDetails')
export default class PetQuoteDetails extends QuoteDetails<PetSchemeQuoteResult> {
  @JsonProperty('proposer', PetProposer)
  proposer: PetProposer = new PetProposer()

  @JsonProperty('pets', [PetRiskPet])
  pets: PetRiskPet[] = []
}

@JsonObject('PetMTAQuoteDetails')
export class PetMTAQuoteDetails extends PetQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('hasUpgradableVAP', Boolean)
  hasUpgradableVAP = false

  @JsonProperty('message', String)
  message = ''

  @JsonProperty('hasClaims', Boolean)
  hasClaims = false
}

@JsonObject('PetRenewalQuoteDetails')
export class PetRenewalQuoteDetails extends PetQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}
